import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download/69c9730dc3f84800139df2b1/ovationprograms/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69c9730dc3f84800139df2b1/ovationprograms/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c9730dc3f84800139df2b1/ovationprograms/src/styles/tailwind.css");
